import { styled } from '@mui/material'

export const LayoutContainerSt = styled('div')`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
  padding: 0;
`
